<template>
    <div :class="[css]">
        <v-btn @click="back()"
               color="primary"
               fab
               large
               dark >
            <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
    </div>
</template>

<script>
    export default {
        name: "fab-btn-back",
        props: {
            css: {default: 'fabBtnBottomRight'},
        },
        methods: {
            back(){
                if ( this.handleBackInComponent ) {
                    this.$emit('back');
                } else {
                    window.history.back();
                }
            },
        },
    }
</script>

<style scoped>
    .fabBtnBottomRight {position: fixed; bottom: 15px; right: 15px}
</style>